module.exports = __webpack_public_path__ + "static/img/LI.6e8d9e2c.jpg";